import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import { css, styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import type { JSX, ReactNode, SyntheticEvent } from 'react';

interface MenuButtonItemProps {
  disabled: boolean;
  isAllowedMessage: string;
  topDivider?: boolean;
  danger?: boolean;
  label: string;
  onClick: (e: SyntheticEvent) => void;
  hide: boolean;
  startIcon?: ReactNode;
}

const StyledMenuItem = styled(MenuItem, { shouldForwardProp: prop => prop !== 'isDanger' })<{ isDanger?: boolean }>`
  min-width: 150px;

  ${({ isDanger, theme }) =>
    isDanger &&
    css`
      color: ${theme.palette.error.main};
      :hover {
        color: ${theme.palette.error.contrastText};
        background-color: ${theme.palette.error.main};
      }
    `}
`;

export function MenuButtonItem(props: MenuButtonItemProps): JSX.Element | null {
  const { disabled, topDivider, onClick, label, isAllowedMessage, danger, hide, startIcon } = props;

  if (hide) {
    return null;
  }

  return (
    <Tooltip title={isAllowedMessage}>
      <div>
        {topDivider && <Divider />}
        <StyledMenuItem
          onClick={e => onClick(e)}
          disabled={disabled}
          isDanger={danger}
          data-test={props['data-test'] || 'actions-item'}
          sx={{
            display: 'flex',
            gap: 0.75,
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}
        >
          {startIcon}
          {label}
        </StyledMenuItem>
      </div>
    </Tooltip>
  );
}
